import { Component, OnInit } from '@angular/core';
import { CatService } from "../services/cat/cat.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    constructor(private _catService: CatService,
        private _activatedRoute: ActivatedRoute) {

        this._activatedRoute.queryParams.subscribe(params => {
            //if (params["targetAudience"] && params["locale"]) {
            if (params["locale"]) {
                //this._catService.targetAudience = params["targetAudience"];
                this._catService.setLocale(params["locale"]);
            }
        });

    }

}
